//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, destroy, _ORDER_TYPE, _ORDER_TYPE_COLOR, _ORDER_STATUS, _ORDER_STATUS_COLOR, _TICKET_TYPE } from '@/apis/order'
import moment from 'moment';
export default {
    data() {
        return {
            config: {
                //運動類型
                status: [],
                orderType: [],
                ticketType: [],
            },
            searchQuery: {
                orderNo: "",
                memberPhone: "",
                memberName: "",
                venueCode: "",
                fieldCode: "",
                orderType: "",
                orderStatus: "",
                sDate: "",
                eDate: "",
                ticketType: "1",
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '訂單類型', key: 'orderType', scopedSlots: { customRender: 'orderTypeSlot' }, width: 120 },
            { title: '場次類型', key: 'ticketType', scopedSlots: { customRender: 'ticketTypeSlot' }, width: 120 },
            { title: '編號', dataIndex: 'orderNo', key: 'orderNo', width: 300 },
            { title: '消費點數', dataIndex: 'consumedPoints', key: 'consumedPoints', width: 120 },
            { title: '數量', dataIndex: 'ticketCount', key: 'ticketCount', width: 120 },
            { title: '客戶姓名', dataIndex: 'memberName', key: 'memberName', width: 180 },
            { title: '會員手機', dataIndex: 'memberPhone', key: 'memberPhone', width: 180 },
            { title: '票卷狀態', key: 'status', scopedSlots: { customRender: 'statusSlot' }, width: 160 },
            { title: '核銷狀態', key: 'checkState', scopedSlots: { customRender: 'checkStatusSlot' }, width: 160 },
            { title: '場館', dataIndex: 'venueName', key: 'venueName', width: 180 },
            { title: '場地', dataIndex: 'fieldName', key: 'fieldName', width: 180 },
            { title: '場次', dataIndex: 'timeSlotName', key: 'timeSlotName', width: 180 },
            { title: '日期', key: 'date', scopedSlots: { customRender: 'dateSlot' }, width: 180 },
            { title: '聯系人', dataIndex: 'contactName', key: 'contactName', width: 180 },
            { title: '聯系人電話', dataIndex: 'contactPhone', key: 'contactPhone', width: 180 },
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        moment,
        onChangeTicketType() {
            this.onPageLoad()
        },
        onChangeDate(value) {
            console.log(`output->value`, value)
            if (value.length > 0) {
                this.searchQuery.sDate = value[0].format('YYYY-MM-DD 00:00:00')
                this.searchQuery.eDate = value[1].format('YYYY-MM-DD 23:59:59')
            } else {
                this.searchQuery.sDate = "";
                this.searchQuery.eDate = "";
            }
        },
        _getOrderTypeText(value) {
            return _ORDER_TYPE[value] !== undefined ? _ORDER_TYPE[value] : '-';
        },
        _getOrderTypeTextColor(value) {
            return _ORDER_TYPE_COLOR[value] !== undefined ? _ORDER_TYPE_COLOR[value] : '-';
        },

        async onPageConfig() {
            try {

                let _status = [], _order_type = [], _ticketType = [];

                Object.keys(_ORDER_STATUS).forEach(value => {
                    _status.push({
                        id: value,
                        name: _ORDER_STATUS[value]
                    })
                });
                this.config.status = _status;

                Object.keys(_TICKET_TYPE).forEach(value => {
                    _ticketType.push({
                        id: value,
                        name: _TICKET_TYPE[value]
                    })
                });
                this.config.ticketType = _ticketType;


                Object.keys(_ORDER_TYPE).forEach(value => {
                    _order_type.push({
                        id: value,
                        name: _ORDER_TYPE[value]
                    })
                });
                this.config.orderType = _order_type;


            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.records = this.parseRecords(res.data.records);
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        parseRecords(records) {
            const _this = this;
            records.forEach(order => {
                order.order_type_text = _this._getOrderTypeText(order.orderType);
                order.order_type_color = _this._getOrderTypeTextColor(order.orderType);
                order.order_status_text = _this._getOrderStatusText(order.orderStatus);
                order.order_status_color = _this._getOrderStatusColor(order.orderStatus);
                order.ticketTypeText = _this.getTicketTypeText(order.ticketType);

            })

            return records;
        },
        getTicketTypeText(code) {
            return _TICKET_TYPE[code] !== undefined ? _TICKET_TYPE[code] : '';
        },
        _getOrderStatusText(value) {
            return _ORDER_STATUS[value] !== undefined ? _ORDER_STATUS[value] : '';
        },
        _getOrderStatusColor(value) {
            return _ORDER_STATUS_COLOR[value] !== undefined ? _ORDER_STATUS_COLOR[value] : '';
        },
        //獲取運動類型名稱
        getSportTypeName(code) {
            if (code && this.config.motions) {
                const data = this.config.motions.filter(item => item.typeCode == code);
                if (data && data.length > 0) {
                    return data[0].name
                }
            }
            return code;
        },

        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        //狀態更新
        async handleOnEditState(item, status) {
            //edit state
            try {
                const res = await venues_changeState(item.id, status);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //刪除行
        async handleOnDelete(item) {
            try {
                const res = await destroy(item.id);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                console.log('delete error', error);
            }
        },
        handleToDetails(id) {
            this.$router.push(`/gymnasium/${id}`);
        },
        handleToForm(id) {
            if (id > 0) {
                this.$router.push(`/activity/edit/${id}`);
            } else {
                this.$router.push('/activity/add');
            }

        }
    }
}
